import React from 'react';

function Backdrop() {

    return (
        <div className="backdrop">
        </div>
      )
}
  
export default Backdrop;
